import { render, staticRenderFns } from "./EscolherCor.vue?vue&type=template&id=30b15209&scoped=true&"
import script from "./EscolherCor.vue?vue&type=script&lang=js&"
export * from "./EscolherCor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b15209",
  null
  
)

export default component.exports